<template>
	<div class="event-prize-page">
		<div class="event-prize-inner">
			<!-- 데이터 로딩 완료 -->
			<template v-if="loaded && eventJoinData">
				<div class="event-prize-image-box">
					<v-img v-if="prizeImage" :src="prizeImage" eager contain class="event-prize-image" />
				</div>

				<div class="event-prize-info">
					<div class="event-prize-info-line bold">{{ eventJoinData.name }} 고객님</div>
					<div class="event-prize-info-line">{{ phoneDisplay }}</div>
					<div class="event-prize-info-line bold product">{{ eventJoinData.winnterProduct }}</div>
					<div class="event-prize-info-line date">{{ eventJoinData.created_at | moment('YYYY-MM-DD HH:mm') }}</div>
				</div>

				<!-- 수령 완료 상태 -->
				<div v-if="isReceived" class="event-prize-done">
					<div><span class="event-prize-done-icon">✔</span> 경품 수령 완료</div>
					<div class="event-prize-done-date" v-if="receiptDisplay">수령일시 : {{ receiptDisplay }}</div>
				</div>

				<!-- 수령 확인 버튼 -->
				<v-btn v-else color="#1e88e5" x-large dark block height="60" class="event-prize-btn" :loading="submitting" @click="confirmReceipt">
					경품 수령 확인
				</v-btn>

				<div class="event-prize-notice text-left">
					※ 경품 수령 확인 버튼은 수령처에서 직원 확인 후<br />
					진행해 주시기 바랍니다.
				</div>
			</template>

			<!-- 데이터 없음 -->
			<template v-else-if="loaded && !eventJoinData">
				<div class="event-prize-empty">유효하지 않은 경품 정보입니다.</div>
			</template>

			<!-- 로딩중 -->
			<template v-else>
				<v-progress-circular indeterminate color="#1e88e5" size="48" class="event-prize-loading" />
			</template>
		</div>
	</div>
</template>

<script>
export default {
	metaInfo() {
		return {
			title: '경품 수령 확인',
		}
	},
	data() {
		return {
			loaded: false,
			submitting: false,
			eventJoinData: null,
		}
	},
	computed: {
		// 수령 여부 (receipt 값이 '수령'일 때만 수령 완료 - 버튼 클릭 시에만 변경)
		isReceived() {
			return !!this.eventJoinData && this.eventJoinData.receipt === '수령'
		},
		// 수령일시 표기 (KST) - 저장 시 +9 보정했으므로 UTC 기준으로 표시하면 KST 벽시계 값이 됨
		receiptDisplay() {
			if (!this.eventJoinData || !this.eventJoinData.receiptDate) return ''
			return this.$moment(this.eventJoinData.receiptDate)
				.utc()
				.format('YYYY-MM-DD HH:mm')
		},
		// 전화번호 표기 (010-1234-5678)
		phoneDisplay() {
			const phone = (this.eventJoinData && this.eventJoinData.phone) || ''
			const num = phone.replace(/[^0-9]/g, '')
			if (num.length === 11) return `${num.slice(0, 3)}-${num.slice(3, 7)}-${num.slice(7)}`
			if (num.length === 10) return `${num.slice(0, 3)}-${num.slice(3, 6)}-${num.slice(6)}`
			return phone
		},
		// 상품명에 따른 경품 이미지
		prizeImage() {
			const data = this.eventJoinData && this.eventJoinData.winnterProduct
			if (data === '발뮤다 더 토스터') return require('@/assets/images/suone_2.jpg')
			else if (data === '스타벅스 하우스 장우산') return require('@/assets/images/suone_4.jpg')
			else if (data === '네스프레소 버츄어 팝') return require('@/assets/images/suone_3.jpg')
			else if (data === '삼성 43인치 무빙스타일 M7') return require('@/assets/images/suone_1.jpg')
			else if (data === '각티슈') return require('@/assets/images/suone_6.jpg')
			else if (data === '진라면') return require('@/assets/images/suone_5.jpg')
			else if (data === '규화의 편지') return require('@/assets/images/1_mother.jpg')
			else if (data === '18k 커플링') return require('@/assets/images/3_mother.jpg')
			else if (data === '제주도 여행권') return require('@/assets/images/2_mother.jpg')
			return null
		},
	},
	mounted() {
		this.fetchEventJoin()
	},
	methods: {
		// 경품(eventJoin) 단건 조회
		async fetchEventJoin() {
			try {
				const res = await this.$store.dispatch('eventJoin', { id: this.$route.params.id })
				this.eventJoinData = res.data.eventJoin
			} catch (err) {
				console.log({ err })
				this.eventJoinData = null
			} finally {
				this.loaded = true
			}
		},
		// 경품 수령 확인 → receipt / receiptDate 업데이트
		async confirmReceipt() {
			if (this.isReceived || this.submitting) return
			this.submitting = true
			try {
				// 서버에 UTC로 저장되면서 -9시간 되는 문제 → KST(+9시간) 보정
				const kstReceiptDate = new Date(Date.now() + 9 * 60 * 60 * 1000)
				const res = await this.$store.dispatch('updateEventJoin', {
					id: this.$route.params.id,
					receipt: '수령',
					receiptDate: kstReceiptDate,
				})
				const updated = res.updateEventJoin.eventJoin
				this.eventJoinData = {
					...this.eventJoinData,
					receipt: updated.receipt,
					receiptDate: updated.receiptDate,
				}
				alert('수령완료')
			} catch (err) {
				console.log({ err })
				alert('수령 확인 처리 중 오류가 발생하였습니다. 다시 시도해 주세요.')
			} finally {
				this.submitting = false
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.event-prize-page {
	min-height: 100vh;
	background-color: #f5f5f5;
	display: flex;
	justify-content: center;
	align-items: flex-start;
	padding: 0;
}
.event-prize-inner {
	width: 100%;
	max-width: 420px;
	background-color: #fff;
	padding: 0 16px 16px;
	text-align: center;
}
.event-prize-image-box {
	margin: 0 auto 12px;
}
.event-prize-image {
	width: 100%;
	max-height: 42vh;
	border-radius: 12px;
}
.event-prize-info {
	margin-bottom: 14px;
}
.event-prize-info-line {
	font-size: 17px;
	line-height: 26px;
	color: #222;
	&.bold {
		font-weight: 700;
	}
	&.product {
		font-size: 20px;
		color: #1e88e5;
	}
	&.date {
		font-size: 15px;
		color: #888;
	}
}
.event-prize-btn {
	font-size: 22px !important;
	font-weight: 700;
	border-radius: 12px;
}
.event-prize-done {
	font-size: 22px;
	font-weight: 700;
	color: #1e88e5;
	padding: 14px 0;
}
.event-prize-done-icon {
	margin-right: 6px;
}
.event-prize-done-date {
	font-size: 15px;
	font-weight: 500;
	color: #555;
	margin-top: 6px;
}
.event-prize-notice {
	font-size: 13px;
	color: #999;
	margin-top: 12px;
	line-height: 18px;
}
.event-prize-empty {
	font-size: 18px;
	color: #555;
	padding: 40px 0;
}
.event-prize-loading {
	margin: 60px auto;
}
</style>
